import { __rest } from "tslib";
import React, { forwardRef } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { ClearedButton } from '@scp/ui-shared/theme/resets';
/**
 * No styling - just a component that returns correct DOM node based on provided props
 * (button, anchor or `<NavLink />`).
 * This fits the case, when a link should look like a button or vice-versa.
 *
 * It's mainly used as base for other components (like `FloatingActionButton`).
 *
 * @example ./__docs__/LinkOrButton.md
 */

export var LinkOrButton = forwardRef(function (_a, ref) {
  var type = _a.type,
      useNavLink = _a.useNavLink,
      to = _a.to,
      href = _a.href,
      disabled = _a.disabled,
      rel = _a.rel,
      target = _a.target,
      dataE2e = _a.dataE2e,
      props = __rest(_a, ["type", "useNavLink", "to", "href", "disabled", "rel", "target", "dataE2e"]);

  if (to && !disabled) {
    if (useNavLink) return React.createElement(NavLink, Object.assign({
      to: to
    }, props, {
      "data-e2e": dataE2e
    }));
    return React.createElement(Link, Object.assign({
      to: to
    }, props, {
      "data-e2e": dataE2e
    }));
  }

  if (href && !disabled) return React.createElement("a", Object.assign({
    ref: ref,
    href: href,
    rel: !rel && target === '_blank' ? 'noopener' : rel,
    target: target,
    "data-e2e": dataE2e
  }, props)); // Button can have type without onClick event (type="submit" for example)

  if (!props.onClick && !type) {
    return React.createElement("span", Object.assign({
      ref: ref,
      "data-e2e": dataE2e
    }, props));
  }

  return React.createElement(ClearedButton, Object.assign({
    ref: ref,
    type: type,
    "data-e2e": dataE2e
  }, props, {
    disabled: disabled
  }));
});